<script>
    import { formatMoney } from '../../../helpers/filters';
    import store from '../../../script/store/checkout';
    import { appendQueryString } from '../../../script/common';

    export default {
        name: 'BaseCheckoutSummary',

        data() {
            return {
                storeState: store.state,

                showProducts: false,
                showProductsList: true,
                showDiscounts: false,

                typedDiscountName: null,
                discountAlert: null,
            };
        },

        computed: {
            cart() {
                return this.storeState.cart.cart;
            },

            discountsBusy() {
                return this.storeState.discount.requests > 0;
            },

            summaryItems() {
                const items = [];

                items.push({
                    label: this.$t('products') + ' (' + this.cart.count_products + ')',
                    value: formatMoney(this.cart.total_products),
                    class: '',
                });

                if (this.cart.carrier_id && this.cart.total_shipping > 0) {
                    items.push({
                        label: this.$t('delivery'),
                        value: formatMoney(this.cart.total_shipping),
                        class: '',
                    });
                } else if (
                    this.cart.carrier_id &&
                    this.cart.total_shipping == 0 &&
                    this.cart.carrier_id != 3
                ) {
                    items.push({
                        label: this.$t('delivery'),
                        value: this.$t('free'),
                        class: 'free-price',
                    });
                } else if (
                    this.cart.carrier_id &&
                    this.cart.total_shipping == 0 &&
                    this.cart.carrier_id == 3
                ) {
                    items.push({
                        label: this.$t('delivery'),
                        value: '-',
                        class: 'free-price',
                    });
                }

                if (this.cart.total_discounts > 0) {
                    items.push({
                        label: this.$t('discounts'),
                        value: '-' + formatMoney(this.cart.total_discounts),
                        class: '',
                    });
                }

                return items;
            },
        },

        methods: {
            getProductImage(checkoutProduct) {
                const image = checkoutProduct.canvas_id
                    ? checkoutProduct.product.img_cover
                    : checkoutProduct.product_image;

                return image ? appendQueryString(image, { auto: 'compress,format', q: 65 }) : null;
            },

            getProductLink(checkoutProduct) {
                return (window.location.href = this.$scope.URL + checkoutProduct.product.link);
            },

            addDiscount() {
                store.discount
                    .addDiscount(this.typedDiscountName)
                    .catch((response) =>
                        this.handleDiscountApiError(
                            response,
                            this.$t('_checkout._discount.errorAdd')
                        )
                    );
            },

            addWholesalerDiscount(wholeasalerDiscount) {
                store.discount.addDiscount(wholeasalerDiscount.name, (errorResponse) =>
                    this.handleDiscountApiError(
                        errorResponse,
                        this.$t('_checkout._discount.errorRemove')
                    )
                );
            },

            removeDiscount(discount) {
                store.discount.removeDiscount(discount.id, (errorResponse) =>
                    this.handleDiscountApiError(
                        errorResponse,
                        this.$t('_checkout._discount.errorRemove')
                    )
                );
            },

            handleDiscountApiError: function (response, message) {
                try {
                    message = response.response.data.data.message;
                } catch (error) {}

                this.discountAlert = {
                    message,
                    isError: true,
                    timeout: 15000,
                };
            },
        },
    };
</script>
